// ============= Constants =============

/**
 * LocalStorage key prefix for tutorial progress.
 * Used to store and retrieve tutorial progress data.
 */
export const TUTORIAL_STORAGE_PREFIX = 'tutorial-';

/**
 * Workspace creation route constant.
 * Used for keyword matching and navigation.
 */
export const WORKSPACE_CREATE_ROUTE = '/workspace/create';

/**
 * Workspace creation action constant.
 * Used for keyword matching.
 */
export const CREATE_WORKSPACE_ACTION = 'create-workspace';

/** localStorage key for question assistant history (question + answer + result options). */
export const QUESTION_ASSISTANT_HISTORY_STORAGE_KEY =
  'LandingPage_questionAssistant_history';

/** Max number of history items to keep. */
export const QUESTION_ASSISTANT_MAX_HISTORY_ITEMS = 20;

/**
 * Keys used to persist the last workspace that was created via the
 * "Create workspace" flow (so the next tutorial can resume in the
 * correct workspace context).
 */
export const LAST_CREATED_WORKSPACE_ID_STORAGE_KEY =
  'LandingPage_lastCreatedWorkspaceId';
export const LAST_CREATED_WORKSPACE_TITLE_STORAGE_KEY =
  'LandingPage_lastCreatedWorkspaceTitle';

/** Default Litium persona ID used when opening Chat from the landing page. */
export const DEFAULT_CHAT_PERSONA_ID = '5d8c2230-1950-4ad1-a1e4-e370eb904ae8';

export const ASK_OPEN_PROGRESS_CREATING = 'Creating new Ask session';
export const ASK_OPEN_PROGRESS_PERSONA = 'Applying default persona';
export const ASK_OPEN_PROGRESS_ASKING = 'Asking question';
export const ASK_OPEN_PROGRESS_GO_WORKSPACE = 'Going to your workspace';
export const ASK_OPEN_PROGRESS_OPEN_ASK = 'Opening Ask';

export const THEME_STORAGE_KEY = 'litium-theme-mode';
export const SESSION_TEMPLATE_STORAGE_KEY = 'litium-session-template-choice';
export const SESSION_TEMPLATE_APPLIED_SESSION_KEY =
  'litium-session-template-applied';
export const LANDING_PAGE_TUTORIAL_SESSION_STORAGE_KEY =
  'LandingPage_question_assistant_active_tutorial_session';

export const RESULT_OPTIONS_HEADER_DEFAULT =
  'Here are some things you can do — pick one:';
export const RESULT_OPTIONS_HEADER_HISTORY =
  'Things you can do — pick one:';
